require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-10-questions-with-david-dent.json") })
        }
      }, "path---news-10-questions-with-david-dent");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-10-questions-with-david-dent!./.cache/json/news-10-questions-with-david-dent.json
// module id = 1408
// module chunks = 231608221292675